/*
const brightBlue= '#4AB0E1';
const green= '#90BF40';
const orange= '#E78636';
const vibrantBlue= '#55C3DA';
const yellow= '#F4C437';
*/

import { FONT_FAMILY } from './fonts';

const overrides = {
    spacing: 4,
    palette: {
      type: 'light',
      primary: {
        main: '#154D93',
      },
      secondary: {
        main: '#51B5E5',
      },
      info: {
        main: '#4AB0E1',
      },
      warning: {
        main: '#E78636',
      },
      success: {
        main: '#90BF40',
      },
      lightGrey:{
        main: '#F6F6F6',
      },
      background: {
        default: "transparent",
      },
    },
    typography: {
      fontFamily: FONT_FAMILY,
      h2: {
       fontSize: '20px',
       lineHeight: '100%',
      },
      button: {
        fontSize: '12px',
        fontWeight: '500',
      },
    },
  
  };
  
  export default overrides;
